import { request } from './http';

export async function getTables() {
    return request('/meta/tables');
  }

export async function getViews() {
    return request('/meta/views');
  }

export async function getTableSchema(tableName) {
    return request(`/meta/schema/${tableName}`);
  }

export async function getAvailableForms(customerId, { facilityId, module } = {}) {
    const qp = new URLSearchParams();
    if (facilityId) qp.set('facilityId', String(facilityId));
    if (module) qp.set('module', String(module));
    return request(`/meta/customers/${customerId}/available-forms${qp.toString() ? `?${qp.toString()}` : ''}`);
  }

export async function setCustomerActiveFormTypes(customerId, payload) {
    return request(`/meta/customers/${customerId}/active-form-types`, {
      method: 'PUT',
      body: JSON.stringify(payload)
    });
  }

export async function getTableKeys(tableName) {
    return request(`/meta/keys/${tableName}`);
  }

export async function getTableFks(tableName) {
    return request(`/meta/fks/${tableName}`);
  }

export async function getTableIndexes(tableName) {
    return request(`/meta/indexes/${tableName}`);
  }

export const metaSchemaMethodsApi = {
  getTables,
  getViews,
  getTableSchema,
  getAvailableForms,
  setCustomerActiveFormTypes,
  getTableKeys,
  getTableFks,
  getTableIndexes,
};

